<div class="error-container">
  <div style="text-align: center">
    <h1>Ha ocurrido un error, intenta mas tarde...</h1>
    <button class="btn btn-primary" (click)="goLogin()">Ir al login</button>
  </div>
</div>
